import React from "react";
import FormTextField from "../../components/form/text";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import FormPasswordField from "../../components/form/password";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import successToast from "../../components/toast/successToast";
import errorToast from "../../components/toast/errorToast";
import { url } from "../../config";

const LoginPage = () => {
  const navigate = useNavigate();
  const initialValues = {
    email: "",
    password: "",
  };

  const validationSchema = Yup.object().shape({
    email: Yup.string().required("Required").email("Invalid email"),
    password: Yup.string().required("Required"),
  });

  const handleSubmit = (values) => {
    console.log(values, "values");
    axios
      .post(`${url}/ffadmin/auth/login`, values)
      .then((response) => {
        successToast(response.message);
        console.log(response, "response");
        localStorage.setItem("accessToken", response?.data?.data?.access_token);
        navigate("/dashboard");
      })
      .catch((error) => {
        console.error("API Error:", error);
        errorToast(error?.response?.data?.message);
      });
  };

  return (
    <main className="flex justify-center items-center h-screen">
      <section className="overflow-auto text-black w-full max-w-[30rem] h-fit bg-white p-10 rounded-lg">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize={true}
        >
          <Form>
            <div className="my-4">
              <FormTextField
                name={"email"}
                label={"Email"}
                placeholder={`Enter your email`}
              />
            </div>
            <div className="my-4">
              <FormPasswordField
                name={"password"}
                label={"Password"}
                placeholder={`Enter your password`}
              />
            </div>
            <div className="flex justify-end">
              <button
                type="submit"
                className="bg-primary rounded-lg px-10 py-3 text-white text-fs_16 font-fw_500"
              >
                SUBMIT
              </button>
            </div>
          </Form>
        </Formik>
      </section>
    </main>
  );
};

export default LoginPage;
